import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Breadcrumbs, Button, Link, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import toast, { Toaster } from "react-hot-toast";
import * as services from "./../../services/saleng";

const AddProduct = () => {
  const [rows, setRows] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    { field: "id", headerName: "ลำดับ", flex: 0, width: 70 },
    {
      field: "image",
      headerName: "รูปภาพ",
      flex: 0,
      width: 100,
      renderCell: (params) => {
        if (params.value) {
          return (
            <img
              src={params.value}
              style={{ width: "50px", height: "50px" }}
              alt=""
            />
          );
        }
      },
    },
    { field: "title", headerName: "ชื่อสินค้า", width: 300, flex: 1 },
    { field: "subCategory", headerName: "หมวดหมู่ย่อย", width: 300, flex: 1 },
    { field: "category", headerName: "ประภท", width: 300, flex: 1 },
  ];

  const handleClick = () => {
    setRowSelectionModel([]);

    rowSelectionModel.forEach((id) => {
      const payload = {
        productId: rows[id - 1].productId,
        title: rows[id - 1].title,
        image: rows[id - 1].image,
        subCategoryId: rows[id - 1].subCategoryId,
        subCategory: rows[id - 1].subCategory,
        categoryId: rows[id - 1].categoryId,
        category: rows[id - 1].category,
      };
      console.log(payload)

      services
        .createProduct(payload)
        .then((response) => {
          toast.success("เพิ่มรายการสำเร็จ!");
          console.log("Product created successfully:", response);

          setRows((prevRows) =>
            prevRows
              .filter((item) => item.id !== id)
              .map((item, index) => ({ ...item, id: index + 1 }))
          );
        })
        .catch((error) => {
          const responseData = error?.response?.data;
          const errorMessage =
            typeof responseData === "string"
              ? responseData
              : responseData?.error || responseData?.message;

          toast.error(errorMessage || "เพิ่มรายการไม่สำเร็จ!");
          console.error("Error creating product:", error);
        });
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await services.getProducts();
        const products = response1.data.data;
        const response2 = await services.getCategories();
        const categories = response2.data.data;

        console.log("categories", categories);
        const productsWithIndex = products.map((item, index) => ({
          ...item,
          id: index + 1,
          productId: item.productId,
        }));

        const filteredSortDataWithIndex = categories
          .flatMap((category) =>
            category.subCategories.flatMap((subCategory) =>
              subCategory.products
                .map((product) => ({
                  productId: product.id,
                  image:
                    product.image ||
                    "https://placehold.co/100x100?text=Not+Found",
                  title: product.title,
                  subCategoryId: subCategory.id,
                  subCategory: subCategory.title,
                  categoryId: category.id,
                  category: category.title,
                }))
                .filter(
                  (item) =>
                    !productsWithIndex.some(
                      (product) => product.productId === item.productId
                    )
                )
            )
          )
          .map((item, index) => ({ ...item, id: index + 1 }));

        // console.log("productsWithIndex: ", productsWithIndex)
        // console.log("filteredSortDataWithIndex: ", filteredSortDataWithIndex)

        setRows(filteredSortDataWithIndex);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 2, mb: 2 }}>
        <Link underline="hover" color="inherit" href="/">
          หน้าแรก
        </Link>
        <Link underline="hover" color="inherit" href="/products">
          รายการสินค้า
        </Link>
        <Typography color="text.primary">เพิ่มรายการสินค้า</Typography>
      </Breadcrumbs>
      <Toaster position="bottom-left" reverseOrder={false} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between", // แยกซ้าย-ขวา
          alignItems: "center", // จัดให้อยู่ตรงกลางแนวตั้ง
          mb: 2,
        }}
      >
        <Typography component="h2" variant="h5">
          รายการสินค้า
        </Typography>

        <Button color="success" variant="contained" onClick={handleClick}>
          เพิ่มรายการสินค้า
        </Button>
      </Box>
      <Box sx={{ flex: 1, position: "relative" }}>
        <Box sx={{ position: "absolute", inset: 0 }}>
          <Paper>
            <DataGrid
              rows={rows}
              columns={columns}
              checkboxSelection
              onRowSelectionModelChange={(newRowSelectionModel) => {
                const selectedRows = rows.filter((row) =>
                  newRowSelectionModel.includes(row.id)
                );
                console.log("Selected Rows:", selectedRows);
                setRowSelectionModel(newRowSelectionModel);
              }}
              rowSelectionModel={rowSelectionModel}
              loading={loading}
              slotProps={{
                loadingOverlay: {
                  variant: "skeleton",
                  noRowsVariant: "skeleton",
                },
              }}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 25 },
                },
              }}
              pageSizeOptions={[25, 50, 100]}
            />
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default AddProduct;
